export default __webpack_public_path__ + "static/media/no_menu_icon.c1eaa403.svg";